import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {navigateToUserPage} from 'orgs/UserPage';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

import MembersTable from './MembersTable';
import * as OrganizationConstants from './OrganizationConstants';
import PendingMembersTable from './PendingMembersTable';

export interface OrganizationMembersTabProps {
  organization: {id: string};
  organizationMembers?: Array<OrganizationConstants.Member>;
  organizationMemberInvites: Array<OrganizationConstants.MemberInvite>;
  organizationMemberRequests: Array<OrganizationConstants.MemberRequest>;
  isCurrentUserMember: boolean;
  canManageRoles: boolean;
  userIdToMemberInfo: {[userId: string]: OrganizationConstants.MemberInfo} | null;
}

export default function OrganizationMembersTab(props: OrganizationMembersTabProps): JSX.Element {
  if (!props.organizationMembers || !props.userIdToMemberInfo) {
    return <CenteredHorizontalThrobber />;
  }

  return (
    <div>
      <PendingMembersTable
        className="u-large-spacing-bottom"
        invites={props.organizationMemberInvites}
        canManageRoles={props.canManageRoles}
        requests={props.organizationMemberRequests}
        organizationId={props.organization.id}
      />
      <MembersTable
        groupId={props.organization.id}
        groupType={ModelTypeConstants.ORGANIZATION}
        canManageRoles={props.canManageRoles}
        members={props.organizationMembers}
        shouldShowMemberInfo={props.isCurrentUserMember || props.canManageRoles}
        userIdToMemberInfo={props.userIdToMemberInfo}
        onRowClick={function (row: {id: string}) {
          navigateToUserPage(row.id);
        }}
      />
    </div>
  );
}
